// In src/store/useChartData.ts
import { create } from 'zustand';
import { ChartSlice, createChartSlice } from './chartSlice'; // Assumendo che chartSlice.ts esista

const useChartData = create<ChartSlice>()((...a) => ({
  ...createChartSlice(...a),
}));

export default useChartData;